import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DivisionService } from 'src/app/services/division.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { PaccsbookingService } from 'src/app/services/paccsbooking.service';
import { DepartmentType } from 'src/enum/departmenttype';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { AdministrativeMappingService } from 'src/app/services/administrative-mapping.service';
import { ShowDailyReportComponent } from '../../reports/showdailyreport/showdailyreport.component';

// Filter screen for ReportType.DBTDivisionWiseFlowProgressReport (71) - the division-level twin of
// dbtdistrictwiseflowprogressreport (67): same per-stage funnel/RDLC layout, one row per division.
// Filters (financial year, GO, scheme, component, category, region/division)
// and their cascading lookups are the same ones reports/villagewisereport uses.
@Component({
  selector: 'app-dbtdivisionwiseflowprogressreport',
  templateUrl: './dbtdivisionwiseflowprogressreport.component.html',
  styleUrls: ['./dbtdivisionwiseflowprogressreport.component.scss']
})
export class DbtDivisionWiseFlowProgressReportComponent implements OnInit {

  form: FormGroup;

  vehicalyearList: any[] = [];
  filtervehicalyearList: any[] = [];
  departmentList: any[] = [];
  filterDepartmentList: any[] = [];
  GoList: any[] = [];
  filterGoList: any[] = [];
  SchemeList: any[] = [];
  filterSchemeList: any[] = [];
  ComponentList: any[] = [];
  filterComponentList: any[] = [];
  communityList: any[] = [];
  filtercommunityList: any[] = [];
  regionList: any[] = [];
  filterregionList: any[] = [];
  divisionList: any[] = [];
  filterdivisionList: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private vehicleService: VehicleService,
    private paccsbookingService: PaccsbookingService,
    private divisionService: DivisionService,
    private cashBookingService: CashBookingService,
    private administrativeMappingService: AdministrativeMappingService,
    public tripDialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.financialyearListLookup();
    this.getCommuntyList();
  }

  initializeForm(): void {
    this.form = this.formBuilder.group({
      financialyearId: ['', Validators.required],
      departmentId: [null, Validators.required],
      goid: [null, Validators.required],
      schemeId: [null, Validators.required],
      componentId: [null, Validators.required],
      community: ['', Validators.required],
      regionId: [null, Validators.required],
      divisionId: [0]
    });
  }

  private validateFormControl(): void {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  financialyearListLookup(): void {
    this.vehicleService.vehicletargetFinancialyear(true).subscribe((result: any) => {
      this.vehicalyearList = result || [];
      this.filtervehicalyearList = this.vehicalyearList.slice();

      const today = new Date();
      const currentYear = today.getFullYear();
      const financialYear = today.getMonth() <= 2
        ? 'FY ' + ((currentYear - 1).toString() + '-' + currentYear.toString().slice(-2))
        : 'FY ' + (currentYear.toString() + '-' + (currentYear + 1).toString().slice(-2));
      const cur = this.filtervehicalyearList.find(i => i.value == financialYear);
      if (cur) {
        this.form.controls['financialyearId'].setValue(cur.key);
        this.financialYearChange();
      }
    });
  }

  financialYearChange(): void {
    this.form.controls['departmentId'].setValue(null);
    this.form.controls['goid'].setValue('');
    this.form.controls['schemeId'].setValue('');
    this.form.controls['componentId'].setValue('');
    this.form.controls['regionId'].setValue(0);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['community'].setValue('');
    this.departmentList = [];
    this.filterDepartmentList = [];
    this.GoList = [];
    this.filterGoList = [];
    this.filterSchemeList = [];
    this.filterComponentList = [];
    this.divisionList = [];
    this.filterdivisionList = [];

    this.getLookupRegion();
    this.getDepartments();
  }

  getDepartments(): void {
    this.vehicleService.getDepartmentLookupData(true).subscribe((result: any) => {
      this.departmentList = result || [];
      this.filterDepartmentList = this.departmentList.slice();

      const smam = this.filterDepartmentList.find(d => d.key === DepartmentType.SMAM);
      if (smam) {
        this.form.controls['departmentId'].setValue(smam.key);
      } else if (this.filterDepartmentList.length === 1) {
        this.form.controls['departmentId'].setValue(this.filterDepartmentList[0].key);
      }
      this.departmentChange();
    });
  }

  departmentChange(): void {
    this.form.controls['goid'].setValue('');
    this.form.controls['schemeId'].setValue('');
    this.form.controls['componentId'].setValue('');
    this.GoList = [];
    this.filterGoList = [];
    this.SchemeList = [];
    this.filterSchemeList = [];
    this.ComponentList = [];
    this.filterComponentList = [];
    const financialYearId = this.form.value.financialyearId ?? 0;
    const departmentId = this.form.value.departmentId ?? 0;
    if (!departmentId) {
      return;
    }
    this.paccsbookingService.getGoListbyId(financialYearId, departmentId, true).subscribe((result: any) => {
      this.GoList = result || [];
      this.filterGoList = this.GoList.slice();
      if (this.filterGoList.length === 1) {
        this.form.controls['goid'].setValue(this.filterGoList[0].key);
        this.golistChange();
      }
    });
  }

  golistChange(): void {
    this.form.controls['schemeId'].setValue('');
    this.form.controls['componentId'].setValue('');
    this.filterComponentList = [];
    this.divisionService.getSchemaListbyId(true, this.form.value.goid).subscribe((result: any) => {
      this.SchemeList = result || [];
      this.filterSchemeList = this.SchemeList.slice();
      if (this.filterSchemeList.length === 1) {
        this.form.controls['schemeId'].setValue(this.filterSchemeList[0].key);
        this.schemaListChange();
      }
    });
  }

  schemaListChange(): void {
    this.form.controls['componentId'].setValue('');
    this.divisionService.getComponetListbyId(this.form.value.goid, this.form.value.schemeId, true).subscribe((result: any) => {
      this.ComponentList = result || [];
      this.filterComponentList = _.orderBy(this.ComponentList, ['value'], ['asc']);
      if (this.filterComponentList.length === 1) {
        this.form.controls['componentId'].setValue(this.filterComponentList[0].key);
      }
    });
  }

  getCommuntyList(): void {
    this.cashBookingService.getcommunityLookup(true).subscribe((res: any) => {
      if (res) {
        this.communityList = res;
        this.communityList.unshift({ key: 0, value: 'All' });
        this.filtercommunityList = this.communityList.slice();
      }
    });
  }

  getLookupRegion(): void {
    const refDate = this.form.value.financialyearId ?? 0;
    this.administrativeMappingService.getRegions(refDate, true).subscribe((result: any) => {
      if (result) {
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
        if (this.regionList.length === 1) {
          this.form.controls['regionId'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionId);
        }
      }
    });
  }

  regionChange(): void {
    this.form.controls['divisionId'].setValue(0);
    this.divisionList = [];
    this.filterdivisionList = [];
    this.getLookupDivision(this.form.value.regionId);
  }

  getLookupDivision(id: any): void {
    const refDate = this.form.value.financialyearId ?? 0;
    this.administrativeMappingService.getDivisions(id, refDate, true).subscribe((result: any) => {
      if (result) {
        this.divisionList = result;
        this.filterdivisionList = this.divisionList.slice();
        if (this.divisionList.length === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
        }
      }
    });
  }

  showReport(): void {
    if (!this.form.valid) {
      this.validateFormControl();
      return;
    }
    const v = this.form.value;
    // Shared report viewer (same one the other progress reports use); ReportType 71 picks
    // ReportType.DBTDivisionWiseFlowProgressReport server-side via POST /api/report.
    this.tripDialog.open(ShowDailyReportComponent, {
      autoFocus: false,
      disableClose: true,
      width: '95%',
      height: '90%',
      panelClass: 'mat-dialog-report',
      data: {
        financialyearId: v.financialyearId,
        financialyearIdvalue: _.find(this.vehicalyearList, ['key', v.financialyearId])?.value || '',
        departmentId: v.departmentId,
        GoId: v.goid,
        schemeId: v.schemeId,
        schemeIdvalue: _.find(this.SchemeList, ['key', v.schemeId])?.value || 'All',
        componentId: v.componentId,
        componentIdvalue: _.find(this.ComponentList, ['key', v.componentId])?.value || 'All',
        community: v.community || 0,
        communityvalue: _.find(this.communityList, ['key', v.community])?.value || 'All',
        RegionId: v.regionId || 0,
        DivisionId: v.divisionId || 0,
        ReportType: 71
      }
    });
  }

  clear(): void {
    this.departmentList = [];
    this.filterDepartmentList = [];
    this.GoList = [];
    this.filterGoList = [];
    this.SchemeList = [];
    this.filterSchemeList = [];
    this.ComponentList = [];
    this.filterComponentList = [];
    this.regionList = [];
    this.filterregionList = [];
    this.divisionList = [];
    this.filterdivisionList = [];
    this.initializeForm();
    this.financialyearListLookup();
  }
}
